import { gql } from '@/__generated__';

const GET_UPDATE_DEVICE_FIELDS = gql(`#graphql
  query DeviceConfiguration_GetUpdateDeviceFields($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      shares
      profile {
        id
        name
        alias
        originalName
        type: type2
        icnCollection {
          id
          name
        }
        organization {
          id
          name
        }
        location {
          latitude
          longitude
        }
      }
    }
  }
`);

export default GET_UPDATE_DEVICE_FIELDS;
